<!-- =========================================================================================
    File Name: TableMiscellaneous.vue
    Description: Combine filter,sorter, pagination etc.
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vx-card title="User List">
    <!-- <p>
      You can add a
      <strong>filtered, sorted, paginated and multi selected</strong> table with combination of the
      <code>search</code>,
      <code>multiple</code> and
      <code>pagination</code> properties for example
    </p>-->
    <!-- <br /> -->
    <vs-button color="primary" type="border" icon="add" to="user/create"
      >Create User</vs-button
    >
    <br>
    <vs-table
      v-model="selected"
      stripe
    
     
     
      :data="users"
      id="button-with-loading"
    >
      <template slot="thead">
        <vs-th sort-key="email">Email</vs-th>
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="role">Role</vs-th>

        <vs-th sort-key="created_at">Created At</vs-th>
        <vs-th sort-key="title">Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="tr.email">{{ tr.email }}</vs-td>
          <vs-td :data="tr.name">{{ tr.name }}</vs-td>
          <vs-td :data="tr.role">
            <span v-if="tr.role==3">Admin</span>
            <span v-else>Mitra</span>
          </vs-td>
          <vs-td :data="tr.created_at">{{ format_date(tr.created_at) }}</vs-td>
          <vs-td :data="tr.role">
            <div class="flex">
              <vs-button
                type="border"
                size="small"
                icon-pack="feather"
                icon="icon-edit"
                color="warning"
                class="mr-2"
                @click="editUser(tr.id)"
              ></vs-button>
              
              <vs-button
                type="border"
                size="small"
                icon-pack="feather"
                icon="icon-trash"
                color="danger"
                @click="deleteAlert('danger', tr.id)"
              ></vs-button>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <template>
     <br>
      <div>
        <vs-pagination :total="10" v-model="page" :max="10"></vs-pagination>
        </div>
      </template>

    <!-- <prism language="js" class="rounded-lg">{{ selected }}</prism> -->
  </vx-card>
</template>

<script>
import axios120 from '../../../axios120'
import Prism from 'vue-prism-component'
import moment from 'moment'
export default {
  data() {
    return {
      'selected': [],
      'tableList': [
        'vs-th: Component',
        'vs-tr: Component',
        'vs-td: Component',
        'thread: Slot',
        'tbody: Slot',
        'header: Slot'
      ],
      'users': [],
      'colorAlert': 'primary',
      'titleAlert': 'Alert',
      'activeAlert': false,
      'valueInput': '',
      'userAuth': this.$store.getters.userAuth,
      'deleteId': null,
      page: 1,
      limit: 10,
      max_page:10

    }
  },
  mounted() {
    this.getUsers()
  },
  watch: {
    page(newValue, oldValue) {
      this.getUsers()

    }


  },
  methods: {
    getUsers() {
      //console.log('ini mounted')
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading",
        scale: 0.45
      })
      //axios120.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.getters.tokenAuth
      axios120.get(`/ecommerce/web/user?limit=` + this.limit + '&page=' + this.page + '&is_all=' + 1, {})
        .then(res => {
          if (res.status != 200) {
            console.log(res.status)
            //   this.errorRecover = true
            //   this.messageRecover = 'Email tidak terdaftar!'
          } else {
            console.log(res)
            this.users = res.data.data
            this.max_page = res.data.last_page
          }
          this.$vs.loading.close("#button-with-loading > .con-vs-loading")

        })
        .catch(error => {
          console.log(error.response)
          this.$vs.loading.close("#button-with-loading > .con-vs-loading")
        })

    },
    format_date(value) {
      if (value && value != '-000001-11-29T16:52:48.000000Z') {
        return moment(String(value)).format('YYYY-MM-DD')
      }
      else{
        return   '0000-00-00'
      }
    },
    deleteAlert(color, id) {
      this.colorAlert = color
      this.deleteId = id
      console.log(`masuk delete${this.deleteId}`)
      this.$vs.dialog({
        color: this.colorAlert,
        title: 'Apa anda yakin?',
        text: 'Setelah dihapus data ini tidak bisa diakses lagi',
        accept: this.deleteUser
      })
    },

    deleteUser() {
      console.log(`masuk delete${this.deleteId}`)
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading",
        scale: 0.45
      })
      axios120.delete(`/ecommerce/web/user/${this.deleteId}`, {})
        .then(res => {
          if (res.status != 200) {
            console.log(res.status)
          } else {
            this.$vs.loading.close("#button-with-loading > .con-vs-loading")

            this.$vs.notify({
              color: 'success',
              title: 'Success!',
              text: 'Success delete user'
            })
            this.getUsers()

          }
        })
        .catch(error => {
          console.log(error.response)
          this.$vs.loading.close("#button-with-loading > .con-vs-loading")
        })


    },
    editUser(id) {
      console.log(id)
      this.$router.push(`/user/edit/${id}`)
    } 

  },
  components: {
    Prism
  }
}
</script>
